module.exports = __webpack_public_path__ + "static/media/CIMG5159a.69bdf888.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/climb/CIMG5159a.JPG
// module id = 169
// module chunks = 0